export const he = {
  logo: 'הסדנא של ענבל',
  nav: {
    categories: 'קטגוריות',
    myOrders: 'הזמנות שלי',
    deals: 'קישורי קנייה מומלצים',
    tutorials: 'הדרכות',
    workshops: 'סדנאות',
    shop: 'חנות',
    about: 'אודות',
    contact: 'צור קשר',
    admin: 'ניהול',
    cricut: 'קריקט',
    goldsmith: 'צורפות',
    others: 'אחרים',
    teva: 'מייקרים ויצירה מקיימת',
    modeling3d: '3D מידול',
    svgfiles: 'פריסות למיתוג וקבצי SVG',
    sublimation: 'סובלימציה',
    chat: 'צ\'אט AI',
    freeTools: 'כלים חינמיים'
  },
  search: 'חיפוש',
  searchPlaceholder: 'חפש מדריכים, מוצרים, סדנאות...',
  cart: 'עגלה',
  language: 'שפה',
  account: 'חשבון',
  login: 'התחברות',
  logout: 'התנתק'
}; 